<wr-base-dialog status="danger" header="Bearbeiten aktivieren?">
  <p>Achtung: Der Rundgang befindet sich derzeit in Bearbeitung.</p>
  <p><b>Wenn jetzt Änderungen vorgenommen werden, wird der Rundgang in der App fehlerhaft sein.</b></p>
</wr-base-dialog>
